import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Insurer } from 'models/InsurerModel';

const InsurerForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.INSURER, Code.Form.Name.INSURER];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Insurer>({});
  const [cityOptions, setCityOptions] = Hooks.Form.Options();
    
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.Http(Code.File.ACCOUNT+Code.File.TYPE, Code.Option.Common.SELECT, setTypeOptions, setError);
    Files.Json.API(Code.File.CITY, Code.Option.Common.NA, setCityOptions, setError);
  
    API.Data.GetByKeyId<Insurer>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.insurer_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });
    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Box>
                <Field.Text id={Name.Insurer.Name} value={formData.insurer_name} title={Title.Insurer} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <Field.Text id={Name.Insurer.ContactPerson} value={formData.contact_person} title="Contact person" onChange={(e) => Form.Field.Change(e, formData, setFormData)}  />
              </Control.Box>
              <Control.Row>
                <Field.Text id={Name.Insurer.Phone} value={formData.insurer_phone} title={Title.Phone} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]}  />
                <Field.Text id={Name.Insurer.Email} value={formData.insurer_email} title={Title.Email} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.User.Address} value={formData.insurer_address} title={Title.Address} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.City.Id} value={formData.city_id} title={Title.City} options={cityOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[0,50,1]}  />
                <Field.Text id={Name.User.Postal} value={formData.insurer_postal} title={Title.Postal} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Box>
                <Field.Text id={Name.Insurer.Website} value={formData.insurer_website} title="Website" onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
                <Field.Text id={Name.Insurer.Fax} value={formData.insurer_fax} title="Fax No" onChange={(e) => Form.Field.Change(e, formData, setFormData)}  />
                <Field.Text id={Name.Insurer.License} value={formData.insurer_license} title="License No" onChange={(e) => Form.Field.Change(e, formData, setFormData)}  />
              </Control.Box>
              <Control.Row>
                <Field.Text id={Name.Insurer.Registration} value={formData.insurer_registration} title={Title.Registration} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Amount id={Name.Insurer.Limit} value={formData.insurer_limit} title="Credit Limit" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
              </Control.Row>
            </Control.Tab.Content>
            
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default InsurerForm;